/**
 * @generated SignedSource<<d88ddf44c56f50bae7a9d97b3c93b8fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type dividendsPage_DateAddMutation$variables = {
  effectiveDate: any;
};
export type dividendsPage_DateAddMutation$data = {
  readonly capTableDateAdd: {
    readonly added: boolean | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type dividendsPage_DateAddMutation = {
  response: dividendsPage_DateAddMutation$data;
  variables: dividendsPage_DateAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "effectiveDate"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "effectiveDate",
    "variableName": "effectiveDate"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "added",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "dividendsPage_DateAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CapTableDateAddMutationPayload",
        "kind": "LinkedField",
        "name": "capTableDateAdd",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "dividendsPage_DateAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CapTableDateAddMutationPayload",
        "kind": "LinkedField",
        "name": "capTableDateAdd",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1f3eb1c8838b31090749dd3c0d22bbc1",
    "id": null,
    "metadata": {},
    "name": "dividendsPage_DateAddMutation",
    "operationKind": "mutation",
    "text": "mutation dividendsPage_DateAddMutation(\n  $effectiveDate: ISO8601Date!\n) {\n  capTableDateAdd(effectiveDate: $effectiveDate) {\n    added\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ff07311ce402a5d46c44f76ebcd50735";

export default node;
